import { http } from 'services/helpers/BaseApi.ts';

const refreshAccessToken = async ({ refreshToken }) => {
  return await http.post('/oauth/refresh-token', {
    refreshToken,
  });
};

export { refreshAccessToken };
